var React = require('react');

function EditIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"m468.1,43.9c-21.2-21.2-49.4-32.9-79.3-32.9-30,0-58.2,11.7-79.4,32.9l-261,261c-2.9,2.9-4.8,6.5-5.6,10.5l-31.4,161.3c-1.3,6.7 1.1,13.3 5.6,18.3 6.7,7.6 17,5.9 18.3,5.6l161.3-31.4c4-0.8 7.7-2.7 10.5-5.6l261-261c43.8-43.7 43.8-115 0-158.7zm-285.4,386.4l-125.4,24.5 24.4-125.4 207.1-207.1 101,101-207.1,207zm256.6-256.5l-20.6,20.6-101-101 20.6-20.6c45.6-40 85.8-15.2 101,0 27.8,27.8 27.8,73.1 0,101z"})));
}

EditIcon.defaultProps = {"version":"1.1","viewBox":"0 0 512 512","enableBackground":"new 0 0 512 512"};

module.exports = EditIcon;

EditIcon.default = EditIcon;
